import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import style from './dashboardWrapper.module.css';

export default function DashboardWrapper({ children }) {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  return (
    <div>
      <nav className={`${style.nav} ${isNavOpen ? style.active : ''}`}>
        <div className={style.logo}>NexLink</div>
        <div className={`${style.hamburger} ${isNavOpen ? style.open : ''}`} onClick={toggleNav}>
          ☰
        </div>
        <div className={`${style.navLinks} ${isNavOpen ? style.show : ''}`}>
          <Link to="/dashboard" onClick={toggleNav}>Redes Sociales</Link>
          <Link to="/dashboard/profile" onClick={toggleNav}>Perfil</Link>
          <Link to="/signout" onClick={toggleNav}>Cerrar Sesión</Link>
        </div>
      </nav>
      <div className="main-container">{children}</div>
    </div>
  );
}
